module.exports = __webpack_public_path__ + "img/bleuet.33197d98.jpg";